import { render, staticRenderFns } from "./TemplatePriewSms.vue?vue&type=template&id=24ec6f0d&"
import script from "./TemplatePriewSms.vue?vue&type=script&lang=js&"
export * from "./TemplatePriewSms.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePriewSms.vue?vue&type=style&index=0&id=24ec6f0d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports